"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./sass/list.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function List(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "list"
  }, children.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: item.text,
      className: "item"
    }, item.icon ? /*#__PURE__*/_react.default.createElement("img", {
      src: item.icon,
      alt: item.text
    }) : /*#__PURE__*/_react.default.createElement("div", {
      className: "dot"
    }), /*#__PURE__*/_react.default.createElement("span", null, item.text));
  }));
};

List.propTypes = {
  children: _propTypes.default.array
};
List.defaultProps = {
  children: [{
    text: 'Item 1'
  }, {
    text: 'Item 2'
  }]
};
var _default = List;
exports.default = _default;